<template lang='pug'>
	.privacy-policy(id='home')
		v-e24-nav-bar
		headerResources(:srcImage='img', :tall="tall", h1="EasyTitle24.com Privacy Policy")
		contentPrivacy
		v-e24-footer(:build="build")
</template>
<script>
import headerResources from '@/commonSite/header.vue'
import contentPrivacy from '@/components/resources/content-privacy-policy.vue'
import imageHeader from '@/img/privacy-header.jpg'
import readBuild from '../util/readBuild'

export default {
	name: 'privacy-policy',
	components: {
		headerResources,
		contentPrivacy
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	},
	data: function () {
		return {
			build: '',
			img: imageHeader,
			tall: 90
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/views/PrivacyPolicy.vue